import PlanetTransitionScene from '../planetTransitionScene'

export default class JunglePlanetTransitionScene extends PlanetTransitionScene {
  constructor() {
    super(
      'JunglePlanetTransitionScene',
      'JunglePlanetScene',
      'Chapter One',
      `This is the story of Frogault, a courageous Froganian in search of his beloved Froguette.
Last time he saw her, she was gathering spices in the Jungle Planet to make
her delicious bug soup. Ah... just the thought of it makes his mouth drool.

But no matter. He knows the place is dangerous and must find her to make sure that
she is safe!`
    )
  }
}
